import { initializeApp } from 'firebase/app';
import { getAuth, EmailAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import * as firebaseui from 'firebaseui';

const firebaseConfig = {
  apiKey: 'AIzaSyAc05RhfgdPu9Ys-7MJyMAAMb9cNwDd33E',
  authDomain: 'eleven-puzzles-website.firebaseapp.com',
  databaseURL: 'https://eleven-puzzles-website.firebaseio.com',
  projectId: 'eleven-puzzles-website',
  storageBucket: 'eleven-puzzles-website.appspot.com',
  messagingSenderId: '456266212854',
  appId: '1:456266212854:web:0154c3eb5c057d495e13d7',
  measurementId: 'G-DHJT98PRSD'
};

export const uiConfig = {
  signInSuccessUrl: '/message/create',
  signInOptions: [
    EmailAuthProvider.EMAIL_PASSWORD_SIGN_IN_METHOD
  ],
  tosUrl: 'https://elevenpuzzles.com/privacy-policy',
  privacyPolicyUrl: () => {
    window.location.assign('https://elevenpuzzles.com/privacy-policy');
  },
  callbacks: {
    signInSuccessWithAuthResult: () => false
  }
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const ui = new firebaseui.auth.AuthUI(auth);

export const db = getFirestore(app);
